import CheckCircle from '@dana/Icons/CheckCircle';
import colorPallete from '@dana/MobiusOverrides/styles/variables';
import translate from '@insite/client-framework/Translate';
import Button from '@insite/mobius/Button';
import { BaseTheme } from '@insite/mobius/globals/baseTheme';
import GridContainer, { GridContainerProps } from '@insite/mobius/GridContainer';
import GridItem, { GridItemProps } from '@insite/mobius/GridItem';
import Typography from '@insite/mobius/Typography';
import { breakpointMediaQueries } from '@insite/mobius/utilities';
import InjectableCss from '@insite/mobius/utilities/InjectableCss';
import React from 'react';
import { css } from 'styled-components';

export interface VerificationEmailStyles {
    doneButton?: InjectableCss;
    emailVerificationMainGridContainer?: GridContainerProps;
    emailVerificationGridItemWrapper?: GridItemProps;
    emailVerificationGridHeading?: GridItemProps;
    emailVerificationGridText?: GridItemProps;
    emailVerificationButtonWrapper?: GridItemProps;
}

export const verificationEmailStyles: VerificationEmailStyles = {

    emailVerificationGridHeading: {
        width: 12,

        css: css`
                gap: 5px;
                display: flex;
                justify-content: center;

                svg {
                    color: green;
                }
        `,

    },
    emailVerificationGridText: {
        width: 12,

        css: css`
                gap: 2px;
                display: flex;
                justify-content: center;
                text-align: center;
        `,
    },
    emailVerificationButtonWrapper: {
        width: 12,
        css: css`
            justify-content: center;
        `
    },
}

const styles = verificationEmailStyles;
interface IndividualEmailVerificationPopupProps {

    closeCustomerSuccessPopup: (closeModel:boolean) => void;
}
type Props = IndividualEmailVerificationPopupProps;
const VerificationEmailSent: React.FC<Props> = ({ closeCustomerSuccessPopup }) => {
    const closePopup = () => {
        closeCustomerSuccessPopup(true);
    }
    return (
            <>
                <GridItem {...styles.emailVerificationGridHeading}>
                    <CheckCircle />
                    <Typography variant="h6" style={{ marginBottom: 0 }}>{translate("Verification Email Sent")}</Typography>
                </GridItem>
                <GridItem {...styles.emailVerificationGridText}>
                    <Typography as="p" lineHeight={1.5}>{translate("Thank you for registering for DanaAftermarket.com")}</Typography>

                </GridItem>
                <GridItem {...styles.emailVerificationGridText}>
                    <Typography as="p" lineHeight={1.5}>{translate("Your account is pending for approval. You will receive a notification when your account is enabled.")}</Typography>
                </GridItem>

                <GridItem {...styles.emailVerificationButtonWrapper}>
                    <Button
                        {...styles.doneButton}
                        type="button"
                        onClick={closePopup}        
                        data-test-selector="verificationEmail_createButton">
                        {translate("Done")}
                    </Button>
                </GridItem>
                </>
    );
};

export default VerificationEmailSent;